"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var mapUseOptionPicker = function mapUseOptionPicker(product) {
  var _product$otherVariant;
  product.otherVariants = product === null || product === void 0 ? void 0 : (_product$otherVariant = product.otherVariants) === null || _product$otherVariant === void 0 ? void 0 : _product$otherVariant.filter(function (variant) {
    return variant.isVisible;
  });
  var productPickedOptions = product.pickedOptions.map(function (option) {
    return {
      id: option.attribute_code,
      name: option.name
    };
  });
  var mapImageAttribute = function mapImageAttribute(data) {
    var swatch_image = data.swatch_image;
    if (!swatch_image) return;
    return {
      altText: swatch_image.alt,
      originalSrc: swatch_image.src,
      variants: [{
        name: "natural",
        aspectRatio: 1,
        srcset: [{
          url: swatch_image.src,
          w: 50,
          h: 50
        }]
      }]
    };
  };
  var options = [];
  productPickedOptions.map(function (productPickedOption) {
    var optionsFromVariants = [];
    var colorOptionPickerData = product.otherVariants.map(function (product) {
      var _product$pickedOption, _product$pickedOption2;
      return {
        optionPickerName: (_product$pickedOption = product.pickedOptions) === null || _product$pickedOption === void 0 ? void 0 : (_product$pickedOption2 = _product$pickedOption.find(function (option) {
          return option.attribute_code === "color_trade_name";
        })) === null || _product$pickedOption2 === void 0 ? void 0 : _product$pickedOption2.name,
        optionPickerImage: product.optionPickerImage
      };
    });
    product.otherVariants.map(function (variant) {
      return variant.pickedOptions;
    }).forEach(function (variantPickedOptions) {
      return variantPickedOptions.filter(function (variantPickedOption) {
        return variantPickedOption.attribute_code === productPickedOption.id;
      }).forEach(function (variantPickedOption) {
        var imageOrImages = function imageOrImages(images) {
          var _images$;
          return images.length === 1 ? (_images$ = images[0]) === null || _images$ === void 0 ? void 0 : _images$.optionPickerImage : images;
        };
        var isUniqueOption = optionsFromVariants.filter(function (optionVariant) {
          return optionVariant.id === variantPickedOption.name;
        }).length === 0;
        if (isUniqueOption) {
          variantPickedOption.attribute_code === "color_trade_name" ? optionsFromVariants.push({
            id: variantPickedOption.name,
            name: variantPickedOption.name,
            image: global.__appConfig__.useDefaultColorPickerImage ? mapImageAttribute(variantPickedOption.data) : imageOrImages(colorOptionPickerData.filter(function (option) {
              return option.optionPickerName === variantPickedOption.name;
            }))
          }) : optionsFromVariants.push({
            id: variantPickedOption.name,
            name: variantPickedOption.name
          });
        }
      });
    });
    var values = [].concat(optionsFromVariants);
    if (values.filter(function (optionFromVariants) {
      return optionFromVariants.name === productPickedOption.name;
    }).length === 0) {
      var productOption = product.pickedOptions.filter(function (option) {
        return option.attribute_code === productPickedOption.id;
      })[0];
      values.push(productPickedOption.id === "color_trade_name" ? {
        id: productOption.name,
        name: productOption.name,
        image: global.__appConfig__.useDefaultColorPickerImage ? mapImageAttribute(productOption.data) : product.optionPickerImage
      } : {
        id: productOption.name,
        name: productOption.name
      });
    }
    options.push({
      id: productPickedOption.id,
      name: productPickedOption.id,
      values: values
    });
  });
  var mapSelectedOptions = function mapSelectedOptions(options) {
    var selectedOptions = {};
    options.map(function (option) {
      selectedOptions[option.attribute_code] = option.name;
    });
    return selectedOptions;
  };
  var mapAttributes = function mapAttributes(options) {
    var attributes = {};
    options.map(function (option) {
      attributes[option.attribute_code] = option.attribute_code === "color_trade_name" ? {
        id: option.name,
        name: option.name,
        image: mapImageAttribute(option.data)
      } : {
        id: option.name,
        name: option.name
      };
    });
    return attributes;
  };
  var products = product.otherVariants ? product.otherVariants.map(function (variant) {
    return _objectSpread(_objectSpread({}, variant), {}, {
      selectedOptions: mapSelectedOptions(variant.pickedOptions)
    }, mapAttributes(variant.pickedOptions));
  }) : [product];
  products.unshift(_objectSpread(_objectSpread({}, product), {}, {
    selectedOptions: _objectSpread({}, mapSelectedOptions(product.pickedOptions))
  }, mapAttributes(product.pickedOptions)));
  var sortOptions = function sortOptions(options) {
    var compareValuesOfKeyName = function compareValuesOfKeyName(keyName) {
      var sortOrder = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "asc";
      return function innerSort(previous, next) {
        if (!previous.hasOwnProperty(keyName) || !next.hasOwnProperty(keyName)) {
          return 0;
        }
        var previousValue = typeof previous[keyName] === "string" ? parseFloat(previous[keyName]) : previous[keyName];
        var nextValue = typeof next[keyName] === "string" ? parseFloat(next[keyName]) : next[keyName];
        var comparison = 0;
        if (previousValue > nextValue) {
          comparison = 1;
        } else if (previousValue < nextValue) {
          comparison = -1;
        }
        return sortOrder === "desc" ? comparison * -1 : comparison;
      };
    };
    options.map(function (option) {
      if (option.id !== "color_trade_name") {
        option.values.sort(compareValuesOfKeyName("name"));
      } else {
        option.values.sort(compareValuesOfKeyName("sku"));
      }
    });
    return options;
  };
  options = sortOptions(options);
  return {
    products: products,
    options: options,
    product: products[0]
  };
};
var _default = mapUseOptionPicker;
exports["default"] = _default;